// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19VRY","colBig":"styles_colBig__dzMqS","colSmall":"styles_colSmall__3n5qG","shopifyNameWrapper":"styles_shopifyNameWrapper__aiwdM"};